import { useEffect, useState } from 'react';

export default function MaintenanceBanner() {
  const [message, setMessage] = useState(null);

  useEffect(() => {
    let cancelled = false;

    fetch(`/maintenance.json?ts=${Date.now()}`, { cache: 'no-store' })
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => {
        if (cancelled || !data?.enabled || !data.from || !data.to) return;
        setMessage(
          `Une maintenance technique est prévue ce jour de ${data.from} à ${data.to}. Certaines fonctionnalités seront temporairement indisponibles. Merci de votre compréhension.`,
        );
      })
      .catch(() => {});

    return () => {
      cancelled = true;
    };
  }, []);

  if (!message) return null;

  return (
    <div className="w-full bg-primary px-[16px] py-[10px] text-center text-[14px] font-[500] leading-[20px] text-white font-jost">
      {message}
    </div>
  );
}
